var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-8 w-8",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 20V10"}}),_c('path',{attrs:{"d":"M18 20V4"}}),_c('path',{attrs:{"d":"M6 20V16"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }